import { render, staticRenderFns } from "./auction-work-item.vue?vue&type=template&id=2a3a3c4c&"
import script from "./auction-work-item.vue?vue&type=script&lang=js&"
export * from "./auction-work-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports